import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class VariantMetafieldMessage extends HTMLElement {
  /** @type {AbortController | null} */
  #abortController = null;

  connectedCallback() {
    this.#abortController = new AbortController();
    const section = this.closest('.shopify-section, dialog');
    section?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate, {
      signal: this.#abortController.signal,
    });
  }

  disconnectedCallback() {
    this.#abortController?.abort();
  }

  /**
   * @param {CustomEvent} event
   */
  #onVariantUpdate = (event) => {
    if (event.detail?.data?.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const next = event.detail?.data?.html?.querySelector('variant-metafield-message');
    if (!next) return;

    morph(this, next, { childrenOnly: true });

    if (next.hasAttribute('hidden')) {
      this.setAttribute('hidden', '');
    } else {
      this.removeAttribute('hidden');
    }
  };
}

if (!customElements.get('variant-metafield-message')) {
  customElements.define('variant-metafield-message', VariantMetafieldMessage);
}
